// src/App.js (modifié)
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ProductionView from './components/ProductionView';
import ManagerPlanningView from './components/ManagerPlanningView';
import ConfigurationView from './components/ConfigurationView';
import ReferentielView from './components/referentiel/ReferentielView';
import ImportsView from './components/imports/ImportsView';
import WorkspaceView from './components/planning/WorkspaceView';
import DisplaysAdmin from './components/displays/DisplaysAdmin';
import TvView from './components/tv/TvView';
import TVDisplayView from './components/TVDisplayView';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import { DataProvider } from './contexts/DataContext';
import { AlertProvider } from './contexts/AlertContext';
import RealTimeService from './services/RealTimeService';

function App() {
  // Connecter le service de temps réel au démarrage de l'application
  useEffect(() => {
    const connectRealTime = async () => {
      try {
        await RealTimeService.connect();
        console.log('Service de temps réel connecté');
      } catch (error) {
        console.error('Erreur de connexion au service de temps réel:', error);
      }
    };
    
    connectRealTime();
    
    // Déconnexion lors du démontage du composant
    return () => {
      RealTimeService.disconnect();
      console.log('Service de temps réel déconnecté');
    };
  }, []);

  return (
    <AlertProvider>
      <DataProvider>
        <Router>
          <div className="PolyPlan">
            <Routes>
              {/* Route de connexion accessible à tous */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* Route principale avec protection */}
              <Route path="/" element={
                <ProtectedRoute requiredRoles={['production', 'manager', 'admin']}>
                  <ProductionView />
                </ProtectedRoute>
              } />
              
              {/* Route du planning réservée aux managers et admins */}
              <Route path="/manager" element={
                <ProtectedRoute requiredRoles={['manager', 'admin']}>
                  <ManagerPlanningView />
                </ProtectedRoute>
              } />
              
              {/* Route de configuration réservée aux admins */}
              <Route path="/configuration" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <ConfigurationView />
                </ProtectedRoute>
              } />

              {/* Référentiel connecté à l'API (lot 1) */}
              <Route path="/referentiel" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <ReferentielView />
                </ProtectedRoute>
              } />

              {/* Suivi des imports ERP (lot 2) */}
              <Route path="/imports" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <ImportsView />
                </ProtectedRoute>
              } />

              {/* Produits & surcharges : onglet du référentiel (lot 3) */}
              <Route path="/produits" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <ReferentielView initialTab="products" />
                </ProtectedRoute>
              } />

              {/* Plan de travail fusionné : planning + affectation (lots 4-5) */}
              <Route path="/planning" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <WorkspaceView />
                </ProtectedRoute>
              } />
              {/* Ancien lien /affectation -> même plan de travail */}
              <Route path="/affectation" element={<Navigate to="/planning" replace />} />
              
              {/* Administration des écrans TV (lot 6) */}
              <Route path="/ecrans" element={
                <ProtectedRoute requiredRoles={['manager','admin']}>
                  <DisplaysAdmin />
                </ProtectedRoute>
              } />

              {/* Vue kiosque TV (lot 6) : publique, authentifiée par jeton d'écran (?k=…) */}
              <Route path="/tv" element={<TvView />} />

              {/* Ancienne vue TV du prototype, conservée le temps de la transition */}
              <Route path="/tv-legacy" element={
                <ProtectedRoute>
                  <TVDisplayView />
                </ProtectedRoute>
              } />

              {/* Redirection par défaut vers la page de connexion */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </DataProvider>
    </AlertProvider>
  );
}

export default App;